// src/common/SearchBox.js
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import {
    FormControl, InputLabel, InputAdornment, IconButton,
    Input,
    OutlinedInput
} from '@mui/material';
import { AppStyle, AppWord } from '../value/AppConst';

const inputLabelStyle = {
    backgroundColor:'white', //paddingTop:-20, marginTop:0
};

const SearchBoxContainer = styled(Box)({
    display: 'inline-flex', alignItems: 'center',
});

export default function SearchBox({
    value,
    label,
    onChangeText,
    width, // if null, 300px
    onEnter, // trigger onEnter when user press Enter key and onEnter is not null.
    onClickSearch, // show search icon only if onClickSearch is not null
    disabled=false,
    style,
}) {

    const boxWidth = width ? width : 240;
    const InputID = 'search-box-input';

    const onChangeSearch = (e) => {
        if(e.target.value) onChangeText(e.target.value.trim());
        else onChangeText('');
    };

    const onKeyDown = (e) => {
        if(e.key === 'Enter' && onEnter) onEnter();
    };

    const onClickSearchIcon = () => {
        if(onClickSearch) onClickSearch();
    };

    const newStyle = style ? style : {};
    newStyle.width = boxWidth;
    return(
        <SearchBoxContainer style={newStyle}>
            <FormControl variant={AppStyle.mui.standard}
                style={{flexGrow:1}}
                    size={AppWord.SMALL}
            >
                <InputLabel htmlFor={InputID}
                    size={AppWord.SMALL}
                    style={inputLabelStyle}
                >{label||'검색'}</InputLabel>
                <Input id={InputID} onChange={onChangeSearch} onKeyDown={onKeyDown}
                    value={value}
                    disabled={disabled}
                    endAdornment={
                        Boolean(value) ?
                        <InputAdornment position='end'>
                            <IconButton
                            onClick={()=>{onChangeText('')}}
                            size={AppWord.SMALL}
                            edge='end'
                            >
                                <ClearIcon style={{fontSize: '0.8rem'}}/>
                            </IconButton>
                        </InputAdornment>
                        :
                        null
                    }
                />
            </FormControl>
            {
                onClickSearch ?
                <IconButton
                    onClick={onClickSearchIcon}
                    size={AppWord.SMALL}
                >
                    <SearchIcon />
                </IconButton>
                : null
            }
        </SearchBoxContainer>
    );
}

/*

				<FormControl variant='outlined' size={AppWord.SMALL}>
					<InputLabel htmlFor={InputID} style={{backgroundColor:'white'}}>검색</InputLabel>
					<OutlinedInput id={InputID} onChange={onChangeSearch}
						value={search}
						disabled={records.length === 0}
						size={AppWord.SMALL}
						endAdornment={
							Boolean(search) ?
							<InputAdornment position={AppWord.END}>
								<IconButton
								onClick={()=>{setSearch('')}}
								size={AppWord.SMALL}
								edge={AppWord.END}
								>
									<ClearIcon />
								</IconButton>
							</InputAdornment>
							:
							null
						}
					/>
				</FormControl>
*/